module.exports = __webpack_public_path__ + "media/images/workplace/instructions/hobbyBtn-f528d6e51056298065d9aa5ab900628b.png";